import { create } from 'zustand';

export interface UserData {
  id?: number;
  companyID: number;
  companyName: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  roles: string[];
  email?: string;
  profilePic?: string;
}

interface AuthState {
  user: UserData | null;
  isAuthenticated: boolean;
  setUser: (user: UserData | null) => void;
  logout: () => void;
}

const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  logout: () => set({ user: null, isAuthenticated: false }),
}));

export default useAuthStore;